import { render } from "./ficheplat.vue?vue&type=template&id=d0b7a38a&scoped=true"
import script from "./ficheplat.vue?vue&type=script&lang=js"
export * from "./ficheplat.vue?vue&type=script&lang=js"

import "./ficheplat.vue?vue&type=style&index=0&id=d0b7a38a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b7a38a"]])

export default __exports__